import { PendingDocumentMove, SpecialPaymentCount } from "../../../api/ClientFileApi";

export const IncomeMaxLength = {
  payerNameAndAddress: 500,
  note: 4000,
  nonRepresentativeReason: 4000,
  selfEmploymentDescription: 4000,
} as const;

export const INCOME_MONTH_COUNT = 3;

export const SELECTABLE_MONTH_COUNT = 6;

export const SPECIAL_PAYMENT_COUNT_OPTIONS: SpecialPaymentCount[] = ["One", "Two", "ThreeOrMore"];

export enum IncomeTypeKey {
  Other = "SONSTIGES_EINKOMMEN",
  OtherNonSeizable = "SONSTIGES_UNPFAENDBARES_EINKOM",
}

export enum IncomeTreatment {
  NonSeizable = "NonSeizable",
  DailyRate = "DailyRate",
  SpecialPaymentsExpected = "SpecialPaymentsExpected",
}

export interface IncomeMonthFormValue {
  month: string | null;
  paidAmount: number | null;
  garnishedAmount: number | null;
  expenseAllowance: number | null;
  familyAllowance: number | null;
  employerSettledExpenses: number | null;
  specialPaymentPaid: boolean | null;
}

export interface IncomeEntryFormValue {
  key: string;
  id: string | null;
  payerNameAndAddress: string | null;
  incomeType: string | null;
  hasSpecialPayments: boolean | null;
  specialPaymentCount: SpecialPaymentCount | null;
  dailyRate: number | null;
  note: string | null;
  isPartiallyGarnished: boolean | null;
  hasEmployerFamilyAllowance: boolean | null;
  hasEmployerSettledExpenses: boolean | null;
  hasBenefitInKind: boolean | null;
  benefitInKindAmount: number | null;
  receivesTips: boolean | null;
  monthlyTipAmount: number | null;
  hasExpenseAllowances: boolean | null;
  isAverageRepresentative: boolean | null;
  nonRepresentativeReason: string | null;
  actualAverageIncome: number | null;
  months: IncomeMonthFormValue[];
}

export interface AssetIncomeFormValues {
  hasSelfEmploymentIncome: boolean | null;
  selfEmploymentDescription: string | null;
  selfEmploymentMonthlyIncome: number | null;
  incomes: IncomeEntryFormValue[];
  incomeProofs: File[];
  documentMoves: PendingDocumentMove[];
}

export interface IncomeTypeTraits {
  isNonSeizable: boolean;
  hasDailyRate: boolean;
  expectsSpecialPayments: boolean;
}
